module.exports = __webpack_public_path__ + "img/coctail-2.0a76ab98.png";